import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import config from '../../config.json';
import { getCommissionStatus } from '../../lib';
import { theme } from '../../styles';
import { Button, ButtonIcon, MainContent, Title } from '../../components';
import { ProfileImage, ClientWrapper, ContactWrapper, IconWrapper, Header } from './style.js';
import ClientLinks from './ClientLinks.jsx';
import {
  ArrowOutwardIcon,
  StylusIcon,
  StylusNoteIcon,
  MailIcon,
  TwitterIcon,
  PixivIcon,
  PatreonIcon,
  DiscordIcon
} from '../../assets/svg';
import profileImg from '../../assets/home/profile.png';

const commStatus = getCommissionStatus();

const ConstRequestButton = commStatus.includes('open') && (
  <Button
    type="Link"
    color="brand"
    size="lg"
    width="fit-content"
    to="/request"
    initial={theme.fadeIn.initial}
    animate={theme.fadeIn.animate}
    transition={theme.fadeIn.transition(theme.delayXl)}
    swapChildren={
      <>
        {config.slotsFilled}/{config.slotsOpen} slots open
        <ButtonIcon>
          <StylusNoteIcon />
        </ButtonIcon>
      </>
    }
  >
    Request a{' '}
    {commStatus.includes('open') &&
      !commStatus.includes('sketchonly') &&
      !commStatus.includes('vtuberonly') &&
      'commission'}
    {commStatus.includes('sketchonly') && 'sketch'}
    {commStatus.includes('vtuber') && 'VTuber'}
    <ButtonIcon style={{ backgroundColor: theme.foregroundColor }}>
      <StylusIcon />
    </ButtonIcon>
  </Button>
);
const Contact = () => {
  const contactItems = [
    {
      name: 'twitter',
      icon: <TwitterIcon />,
      link: config.socialMedia.twitter.link,
      user: config.socialMedia.twitter.username
    },
    {
      name: 'pixiv',
      icon: <PixivIcon />,
      link: config.socialMedia.pixiv.link,
      user: config.socialMedia.pixiv.username
    },
    {
      name: 'patreon',
      icon: <PatreonIcon />,
      link: config.socialMedia.patreon.link,
      user: config.socialMedia.patreon.username
    },
    {
      name: 'discord',
      icon: <DiscordIcon />,
      link: config.socialMedia.discord.link,
      user: config.socialMedia.discord.username
    },
    {
      name: 'email',
      icon: <MailIcon />,
      link: config.socialMedia.email.link,
      user: config.socialMedia.email.username
    }
  ];
  const [timer, setTimer] = useState(true);
  const [active, setActive] = useState('twitter');
  const [activeInd, setActiveInd] = useState(0);


  useEffect(() => {
    if (timer) {
      const timeoutId = setTimeout(() => {
        const nextInd = (activeInd + 1) % contactItems.length;
        setActive(contactItems[nextInd].name);
        setActiveInd(nextInd);
      }, 5000);
      return () => clearTimeout(timeoutId);
    }
  }, [activeInd]);

  return (
    <MainContent $alignItems="center">
      <Header>
        <Title>Contact Me</Title>
        <motion.p
          initial={theme.fadeIn.initial}
          animate={theme.fadeIn.animate}
          transition={theme.fadeIn.transition(theme.delayMd)}
          style={{ whiteSpace: 'pre-line' }}
        >
          {config.contactDescription}
        </motion.p>
      </Header>
      <ContactWrapper>
        <ProfileImage
          src={profileImg}
          initial={theme.fadeIn.initial}
          animate={theme.fadeIn.animate}
          transition={theme.fadeIn.transition(theme.delayLg)}
        />
        <ContactWrapper
          initial={theme.fadeIn.initial}
          animate={theme.fadeIn.animate}
          transition={theme.fadeIn.transition(theme.delayXl)}
        >
          <IconWrapper>
            {contactItems.map((contactItem, ind) => (
              <Button
                key={`contact-link-${ind}`}
                type="button"
                style="fill"
                color={active === contactItem.name ? 'brand' : 'mutedColor'}
                size="md"
                icon={true}
                initial={theme.fadeIn.initial}
                animate={theme.fadeIn.animate}
                transition={theme.fadeIn.transition(ind === 1 ? theme.delayMd : theme.delayLg)}
                onClick={() => {
                  setActive(contactItem.name);
                  setActiveInd(ind);
                  setTimer(false);
                }}
              >
                {contactItem.icon}
              </Button>
            ))}
          </IconWrapper>
          <Button
            type="Link"
            style="fill"
            color="brand"
            size="lg"
            width="fit-content"
            to={contactItems[activeInd].link}
            target="blank"
          >
            {contactItems[activeInd].user}
            <ButtonIcon>
              <ArrowOutwardIcon />
            </ButtonIcon>
          </Button>
        </ContactWrapper>
        {ConstRequestButton}
      </ContactWrapper>

      {/* <ClientWrapper>
      <Title>Clients</Title>
      <motion.p
          initial={theme.fadeIn.initial}
          animate={theme.fadeIn.animate}
          transition={theme.fadeIn.transition(theme.delayMd)}
          style={{ whiteSpace: 'pre-line' }}
        >
          See my commissioned art per client.
        </motion.p>
      <ClientLinks />
        
      </ClientWrapper> */}
    </MainContent>
  );
};

export default Contact;
